import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { JwtModule } from '@auth0/angular-jwt';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ClipboardModule } from 'ngx-clipboard';

import { RouterModule } from '@angular/router';
import { StorageVariables } from '../shared/constants/app.enum';

export function tokenGetter() {
  return localStorage.getItem(StorageVariables.TOKEN)!;
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ClipboardModule,
    RouterModule,
    TranslateModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter,
      },
    }),
    InlineSVGModule.forRoot(),
  ],
  exports: [RouterModule, TranslateModule, JwtModule, ClipboardModule, InlineSVGModule],
})
export class CoreModule {}
